import { render, staticRenderFns } from "./VersionDescription.vue?vue&type=template&id=36e95018&scoped=true"
import script from "./VersionDescription.vue?vue&type=script&lang=js"
export * from "./VersionDescription.vue?vue&type=script&lang=js"
import style0 from "./VersionDescription.vue?vue&type=style&index=0&id=36e95018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e95018",
  null
  
)

export default component.exports